<template>
  <CommonDetail />
</template>
<script>
import CommonDetail from '../components/CommonDetail.vue';
export default {
  name: 'BusinessPurchaseReturnInformDetail',
  components: { CommonDetail },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>
